import { MembershipsBadgesApiClient } from '@fourthwall/services/dist/MembershipsBadgesApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useEditMemberStreakBadgeMutation = createMutationHook(
  MembershipsBadgesApiClient.editMemberStreakBadge,
  {
    mutationKey: ['editMemberStreakBadge'],
  },
)
